import React from "react";
import { ImageBackground, StyleSheet } from "react-native";

export default function ReportBackground({ children, style }) {
  return (
    <ImageBackground
      source={require("../assets/bg-gradation.svg")}
      resizeMode="stretch"
      style={[styles.background, style]}
    >
      {children}
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  background: { flex: 1, backgroundColor: "#F9F2FF" },
});